import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import { useUniqueId } from "../hooks/useUniqueId";

import { getDateString } from "./dateHelper";
import DateSelectionButton from "./DateSelectionButton";

import styles from "./DateSelectionList.scss";

export function DateSelectionList(props) {
  const {
    dates,
    onChange,
    variant,
    name,
    customClass,
    dateConfig,
    ...restProps
  } = props;
  const { id } = restProps;
  const [selectedDate, setSelectedDate] = useState(dates[0]);
  const dateSelectionId =
    id || `date-selection-${useUniqueId("DateSelection", props) + 1}`;
  const dateSelectionName = name || dateSelectionId;

  const onCheck = useCallback(
    (val) => {
      setSelectedDate(val);
      if (onChange) onChange(val);
    },
    [onChange]
  );

  return (
    <div
      className={cx(styles["date-group"], variant, customClass)}
      {...restProps}
    >
      {dates.map((date) => {
        const dateString = getDateString(date);
        const buttonId = `${dateSelectionId}-${dateString}`;

        return (
          <DateSelectionButton
            key={buttonId}
            date={date}
            id={buttonId}
            name={dateSelectionName || dateSelectionId}
            onClick={onCheck}
            variant={
              variant === DateSelectionList.Variants.copy
                ? DateSelectionButton.Variants.copy
                : DateSelectionButton.Variants.additional
            }
            dateConfig={dateConfig}
            checked={selectedDate === date}
          />
        );
      })}
    </div>
  );
}

DateSelectionList.Variants = {
  copy: styles["date-group--copy"],
  additional: styles["date-group--additional"],
};

DateSelectionList.propTypes = {
  dates: PropTypes.arrayOf(PropTypes.instanceOf(Date)).isRequired,
  customClass: PropTypes.string,
  onChange: PropTypes.func,
  variant: PropTypes.string,
  name: PropTypes.string,
  dateConfig: PropTypes.shape({
    locales: PropTypes.string,
    headlineFormat: PropTypes.objectOf(PropTypes.string),
    sublineFormat: PropTypes.objectOf(PropTypes.string),
  }),
};

DateSelectionList.defaultProps = {
  customClass: null,
  onChange: () => {},
  variant: DateSelectionList.Variants.copy,
  name: null,
  dateConfig: {
    locales: "de-DE",
    headlineFormat: { weekday: "short" },
    sublineFormat: { day: "2-digit", month: "2-digit" },
  },
};

DateSelectionList.displayName = "DateSelectionList";

export default DateSelectionList;
